import React from "react";

import Typography from "@mui/material/Typography";

const Step1: React.FC = () => {
  return (
    <Typography color="grey800">
      Усі ваші дані, включно зі згенерованими та надісланими посиланнями, буде назавжди видалено, і їх неможливо буде відновити.
      Будь ласка, продовжуйте лише, якщо ви повністю впевнені у своєму рішенні.
    </Typography>
  );
};

export default Step1;
